// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"f19b5df7","845":"32d49443","975":"c510387c"}[chunkId] + ".chunk.css";
};